import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getCompany = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `department`);
};
export const getSites = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `department/sites`);
};
export const AddCampany = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `department/create`,
    obj,
    {
      headers,
    }
  );
};

export const EditCampany = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `department/update`,
    obj,
    {
      headers,
    }
  );
};

export const DeleteCampany = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `department/delete`,
    obj,
    {
      headers,
    }
  );
};
